import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';

// Keep the iframe out of the initial request waterfall. The responsive
// placeholder still reserves the same space, so deferring the embed does not
// change the layout or the content users see.
const LazyYouTubeEmbed = ({ src, ...props }) => {
    const frameRef = React.useRef(null);
    const [isNearViewport, setIsNearViewport] = React.useState(false);

    React.useEffect(() => {
        if (typeof IntersectionObserver === 'undefined') {
            setIsNearViewport(true);
            return undefined;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsNearViewport(true);
                    observer.disconnect();
                }
            },
            { rootMargin: '300px' }
        );

        if (frameRef.current) {
            observer.observe(frameRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <div
            ref={frameRef}
            style={{ width: '100%', maxWidth: 900, aspectRatio: '16 / 9', margin: '0 auto' }}
        >
            {isNearViewport ? (
                <iframe
                    {...props}
                    src={src}
                    style={{ borderRadius: 12, width: '100%', height: '100%', display: 'block' }}
                />
            ) : null}
        </div>
    );
};

const propTypes = {
    ...SectionTilesProps.types
};

const defaultProps = {
    ...SectionTilesProps.defaults
};

const Video = ({
    className,
    topOuterDivider,
    bottomOuterDivider,
    topDivider,
    bottomDivider,
    hasBgColor,
    invertColor,
    pushLeft,
    ...props
}) => {
    const outerClasses = classNames(
        'testimonial section',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'testimonial-inner section-inner',
        topDivider && 'has-top-divider',
        bottomDivider && 'has-bottom-divider'
    );

    const tilesClasses = classNames('tiles-wrap', pushLeft && 'push-left');

    return (
        <section {...props} className={outerClasses} id="video">
            <div className="container">
                <div className={innerClasses}>
                    <SectionHeader
                        data={{
                            title: 'See how saving becomes finding',
                            paragraph: 'A short walkthrough of sending things to Luckynote, letting them become searchable, and finding them again later.'
                        }}
                        className="center-content"
                    />
                    <div className={tilesClasses}>
                        <LazyYouTubeEmbed
                            src="https://www.youtube-nocookie.com/embed/lDDtsYRZ0-Q"
                            title="YouTube video player"
                            loading="lazy"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            referrerPolicy="strict-origin-when-cross-origin"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

Video.propTypes = propTypes;
Video.defaultProps = defaultProps;

export default Video;
